<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row mt-3">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <b-row>
              <b-col lg="8" class="my-1">
                <b-button v-if="modulePermission.create == 1" @click="AddOwner()" class="btn-outline-primary">
                  <b-icon class="text-center" icon="plus"></b-icon> New Owner
                </b-button>
            </b-col>
             <b-col lg="4" class="my-1">
                  <b-form-group class="mb-0">
                    <b-input-group size="sm">
                      <b-form-input
                        id="filter-input"
                        v-model="filter"
                        type="search"
                        placeholder="Filter"
                      ></b-form-input>

                      <b-input-group-append>
                        <b-button class="btn-secondary" :disabled="!filter" @click="filter = ''"
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
            
            <template>
              <b-table-simple
                :small="true"
                sticky-header
                style="max-height: 395px;"
                striped
                responsive
                hover
              >
                <b-thead>
                  <b-tr>
                    <b-th>No.</b-th>
                    <b-th>Full Name</b-th>
                    <b-th>Phone Number</b-th>
                    <b-th>Email</b-th>
                    <b-th>Address</b-th>
                    <b-th>Sex</b-th>
                    <b-th>Status</b-th>
                    <b-th>Created At</b-th>
                    <b-th>Registered By</b-th>
                    <b-th sticky-column style="height: 45px;"></b-th>
                  </b-tr>
                </b-thead>
                <template v-if="spinner">
                <b-tbody>
                   <b-tr >
                       <b-td colspan="10" class="text-center" style="display: table-cell">
                        <b-spinner
                        style="height: 3rem; width: 3rem;"
                          variant="warning"
                        ></b-spinner>
                       </b-td>
                    </b-tr>
                </b-tbody>
                </template>
                <template v-else>
                  <b-tbody>
                  <template v-if="filterTable.length === 0">
                      <b-tr>
                        <b-td colspan="10" class="text-center">Nothing found</b-td>
                      </b-tr>
                  </template>
                  <template v-else>
                  <b-tr
                    v-for="(item, index) in filterTable"
                    :key="item.id"
                  >
                      <b-td>{{(currentPage - 1) * perPage + index + 1}}</b-td>
                      <b-td>{{item.fullName}}</b-td>
                      <b-td>{{item.phoneNumber}}</b-td>
                      <b-td>{{item.email}}</b-td>
                      <b-td>{{item.address}}</b-td>
                      <b-td>{{item.sex}}</b-td>
                      <b-td>{{item.status}}</b-td>
                      <b-td>{{item.createdDate}}</b-td>
                      <b-td>{{item.registeredBy}}</b-td>
                      <b-td sticky-column style="padding: 0px 0px !important;">
                        <b-row>
                          <b-col md="12" class="mb-2" v-if="modulePermission.update == 1">
                            <b-icon icon="pencil-square" class="btn-icon" title="Edit Owner" @click="EditOwner(item.id)" aria-hidden="true" ></b-icon>
                          </b-col>
                        </b-row>
                      </b-td>
                  </b-tr>
                  </template>
                </b-tbody>
                </template>
              </b-table-simple>
              <b-row>
                <b-col md="3">
                  <b-form-group
                    id="fieldset-horizontal"
                    label-cols="8" label-cols-xs="8" label-size="md"
                    label="records per page"
                    label-for="input-horizontal"
                    label-align-xl="right"  
                  >
                  <b-form-select id="input-horizontal" v-model="perPage" :options="pageOptions" @change="changePerPage"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="9">
                  <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows" @page-click="changePage" align="right"></b-pagination>
                </b-col>
              </b-row>
            </template>
          </card>
        </div>
      </div>
      <div class="row">
        <b-modal
            id="modal-center-add"
            hide-footer
            title="Add Owner"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Add Owner</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                class="text-left"
                @submit.stop.prevent="handleSubmit(submitAddForm)"
              >
                <b-row no-gutters>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="addData.fullName"
                      @update:modelValue="
                        (newValue) => (addData.fullName = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-fullName"
                      name="text-fullName"
                      label="Full Name"
                      class="mb-1 mr-sm-2"
                      description="text-fullName-feedback"
                      validatorName="Full Name"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <VinputGroup
                      inputType="text"
                      :modelValue="addData.phoneNumber"
                      @update:modelValue="
                        (newValue) => (addData.phoneNumber = newValue)
                      "
                      :rules="{ required: true, regex:/^\d{9}$/ }"
                      id="text-phoneNumber"
                      name="text-phoneNumber"
                      label="Phone Number"
                      class="mb-1 mr-sm-2"
                      description="text-phoneNumber-feedback"
                      validatorName="Phone Number"
                      prepend="+251"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="email"
                      :modelValue="addData.email"
                      @update:modelValue="
                        (newValue) => (addData.email = newValue)
                      "
                      :rules="{ email: true }"
                      id="text-email"
                      name="text-email"
                      label="Email"
                      class="mb-1 mr-sm-2"
                      description="text-email-feedback"
                      validatorName="Email"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="addData.address"
                      @update:modelValue="
                        (newValue) => (addData.address = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-address"
                      name="text-address"
                      label="Address"
                      class="mb-1 mr-sm-2"
                      description="text-address-feedback"
                      validatorName="Address"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="addData.sex"
                      @update:modelValue="
                        (newValue) => (addData.sex = newValue)
                      "
                        :options="sexOptions"
                      :rules="{ required: true }"
                      id="text-sex"
                      name="text-sex"
                      label="Sex"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-sex-feedback"
                      validatorName="Sex"
                    />
                  </b-col>

                  <b-col class="mt-2">
                    <b-button type="submit" variant="primary">Submit</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
      </div>
      <div class="row">
        <b-modal
            id="modal-top-EditOwner"
            hide-footer
            title="Edit Owner"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Edit Owner</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                class="text-left"
                @submit.stop.prevent="handleSubmit(submitEditForm)"
              >
                <b-row no-gutters>
                   <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="selectedOwner.fullName"
                      @update:modelValue="
                        (newValue) => (selectedOwner.fullName = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-fullName"
                      name="text-fullName"
                      label="Full Name"
                      class="mb-1 mr-sm-2"
                      description="text-fullName-feedback"
                      validatorName="Full Name"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <VinputGroup
                      inputType="text"
                      :modelValue="selectedOwner.phoneNumber"
                      @update:modelValue="
                        (newValue) => (selectedOwner.phoneNumber = newValue)
                      "
                      :rules="{ required: true, regex:/^\d{9}$/ }"
                      id="text-phoneNumber"
                      name="text-phoneNumber"
                      label="Phone Number"
                      class="mb-1 mr-sm-2"
                      description="text-phoneNumber-feedback"
                      validatorName="Phone Number"
                      prepend="+251"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="email"
                      :modelValue="selectedOwner.email"
                      @update:modelValue="
                        (newValue) => (selectedOwner.email = newValue)
                      "
                      :rules="{ email: true }"
                      id="text-email"
                      name="text-email"
                      label="Email"
                      class="mb-1 mr-sm-2"
                      description="text-email-feedback"
                      validatorName="Email"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="selectedOwner.address"
                      @update:modelValue="
                        (newValue) => (selectedOwner.address = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-address"
                      name="text-address"
                      label="Address"
                      class="mb-1 mr-sm-2"
                      description="text-address-feedback"
                      validatorName="Address"
                    />
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                     <Vselect
                      :modelValue="selectedOwner.sex"
                      @update:modelValue="
                        (newValue) => (selectedOwner.sex = newValue)
                      "
                        :options="sexOptions"
                      :rules="{ required: true }"
                      id="text-sex"
                      name="text-sex"
                      label="Sex"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-sex-feedback"
                      validatorName="Sex"
                    />
                  </b-col>

                  <b-col class="mt-2">
                    <b-button type="submit" variant="primary">Submit</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/Table.vue'
  import Card from 'src/components/Cards/Card.vue'
  import Vinput from 'src/components/Inputs/Vinput.vue'
  import VinputGroup from 'src/components/Inputs/VinputGroup.vue'
  import Vselect from 'src/components/Inputs/Vselect.vue'
  export default {
    components: {
      LTable,
      Card,
      Vinput,
      VinputGroup,
      Vselect
    },
    data () {
      return {
        modulePermission: {
          view: 1,
          create: 0,
          update: 0,
          delete: 0
        },
        totalRows: 0,
        currentPage: 1,
        perPage: 7,
        pageOptions: [
          {value: 7, text: 7},
          {value: 10, text: 10},
          {value: 25, text: 25},
          {value: 50, text: 50},
          {value: 100, text: 100}
        ],
        items: [],
        filter: "",
        addData: {
          fullName: "",
          phoneNumber: "",
          email: "",
          address: "",
          sex: "",
          status: "",
          user: {
            id: parseInt(sessionStorage.getItem("ID"))
          },
          userId: parseInt(sessionStorage.getItem("ID")),
          registeredById: parseInt(sessionStorage.getItem("userID"))
        },
        sexOptions: [
          {text: "Male", value: "Male"},
          {text: "Female", value: "Female"}
        ],
        statusOptions: [
          {text: "Active", value: "Active"},
          {text: "Inactive", value: "Inactive"}
        ],
        selectedOwner: {
          id: null
        },
        spinner: true
      }
    },
    computed: {
      userRole() {
        return sessionStorage.getItem('userRole');
      },
      filterTable() {
        var searchItems = this.items;
        var searchString = this.filter;
        if (searchString === "") {
          return searchItems;
        }
        searchString = searchString.trim().toLowerCase();

        searchItems = searchItems.filter(function (item) {
          if (item.fullName.toLowerCase().indexOf(searchString) !== -1 || 
              item.phoneNumber.toLowerCase().indexOf(searchString) !== -1 ||
              item.email.toLowerCase().indexOf(searchString) !== -1) {
            return item;
          }
        });
        return searchItems;
      },
    },
     mounted() {
      this.getModules();
      this.getOwnersByUser();
      this.$on("AfterComplete", () => {
        this.getOwnersByUser();
      });
    },
    methods: {
      getModules(){
        this.$store.dispatch('getModulesPermission', {userId: sessionStorage.getItem("userID")})
          .then(response=>{
              var modulesList = response.data.modules;
              var OwnerModule = modulesList.filter(x=>x.name === "Owner");
              if(OwnerModule !== null && OwnerModule.length > 0){
                this.modulePermission.view = OwnerModule[0].listData;
                this.modulePermission.create = OwnerModule[0].createData;
                this.modulePermission.update = OwnerModule[0].updateData;
                this.modulePermission.delete = OwnerModule[0].deleteData;
              }
          })
          .catch(error=>{
              console.log(error);
          })
      },
      getOwnersByUser(){
          this.$store.dispatch('getOwnersByUser', {
            userId: sessionStorage.getItem("ID"), 
            page: this.currentPage, 
            line: this.perPage,
            phoneNumber: null,
            createdDate: null
          })
          .then(response=>{
              this.items = response.data.Contents;
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              console.log(error);
          })
          .finally(msg=>{
            this.spinner = false;
          })
      },
      changePage(event, page){
        this.spinner = true;
        this.$store.dispatch('getOwnersByUser', {
          userId: sessionStorage.getItem("ID"), 
          page: page - 1, 
          line: this.perPage,
          phoneNumber: null,
          createdDate: null
        })
          .then(response=>{
              this.items = response.data.content;
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              console.log(error);
          })
          .finally(msg=>{
            this.spinner = false;
          })
      },
      changePerPage(event){
        this.spinner = true;
        this.$store.dispatch('getOwnersByUser', {
          userId: sessionStorage.getItem("ID"), 
          page: this.currentPage - 1, 
          line: this.perPage,
          phoneNumber: null,
          createdDate: null
        })
          .then(response=>{
              this.items = response.data.content;
              this.totalRows = response.data.totalElements;
          })
          .catch(error=>{
              console.log(error);
          })
          .finally(msg=>{
            this.spinner = false;
          })
      },
      AddOwner(){
        this.$bvModal.show('modal-center-add');
      },
      submitAddForm(){
            this.$bvModal.msgBoxConfirm('Are you sure you want to submit this form?', {
                 title: 'Confirm',
                 size: 'sm',
                 buttonSize: 'sm',
                 okVariant: 'success',
                 cancelVariant: 'danger',
                 okTitle: 'YES',
                 cancelTitle: 'NO',
                 bodyClass: 'm-2',
                 hideHeaderClose: false,
                 centered: false
             })
             .then(value => {
                 if(value === true){
                    this.$store.dispatch('AddOwner', this.addData)
                    .then(response=>{
                        this.$notifications.notify(
                          {
                            message: `Owner successfully created.`,
                            horizontalAlign: 'center',
                            verticalAlign: 'top',
                            type: 'success'
                          })
                          this.$bvModal.hide('modal-center-add');
                          this.clearData();
                    })
                    .catch(error=>{
                       this.$notifications.notify(
                          {
                            message: error.response.data,
                            horizontalAlign: 'center',
                            verticalAlign: 'top',
                            type: 'danger'
                          })
                        console.log(error);
                    })
                 }
             })
             .catch(error=>{
                  console.log(error)
             })
      },
      EditOwner(ID){
        var Owner = this.items.filter(item=> item.id == ID)[0];
        this.selectedOwner.fullName = Owner.fullName;
        this.selectedOwner.phoneNumber = Owner.phoneNumber;
        this.selectedOwner.email = Owner.email;
        this.selectedOwner.address = Owner.address;
        this.selectedOwner.sex = Owner.sex;
        this.selectedOwner.status = Owner.status;
        this.selectedOwner.ownerId = Owner.id;
        this.$bvModal.show('modal-top-EditOwner');
      },
      submitEditForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to submit this form?', {
            title: 'Confirm',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            cancelVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            bodyClass: 'm-2',
            hideHeaderClose: false,
            centered: false
        })
        .then(value => {
            if(value === true){
              this.$store.dispatch('EditOwner', this.selectedOwner)
              .then(response=>{
                  this.$notifications.notify(
                    {
                      message: `Owner Successfully Updated.`,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'success'
                    })
                    this.$bvModal.hide('modal-top-EditOwner');
                    this.clearData();
              })
              .catch(error=>{
                console.log(error);
                this.$notifications.notify(
                    {
                      message: error.response.data,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'danger'
                    })
                  console.log(error);
              })
            }
        })
        .catch(error=>{
            console.log(error)
        })
      },
      clearData(){
        this.addData.fullName = "";
        this.addData.phoneNumber = "";
        this.addData.email = "";
        this.addData.address = "";
        this.addData.sex = "";
        this.addData.status = "";
        this.selectedOwner = {};
        this.$emit('AfterComplete');
      }
    },
  }
</script>
<style scoped>
.b-table-sticky-column:last-child {
  right: 0;
}
.text-warning {
    color: rgba(240, 206, 13, 0.937) !important;
}
.btn-icon{
  font-size: 27px !important;
  padding: 3px 5px 3px 5px;
  width: 40px;
  color:  rgb(37, 91, 48);
  border: 2px solid rgb(37, 91, 48);
}
.btn-icon:hover,
.btn-icon:focus {
  cursor: pointer;
  background-color: rgb(37, 91, 48) !important;
  color: rgba(240, 206, 13, 0.937) !important;
  border-radius: 4px;
  transition: .4s;
}
</style>